{
  "name": "npc-admin",
  "version": "3.0.1",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && [object Object] run sentry:sourcemaps",
    "lint": "ng lint",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org rewire-technology --project npc-admin ./dist && sentry-cli sourcemaps upload --org rewire-technology --project npc-admin ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "20.3.4",
    "@angular/compiler": "20.3.4",
    "@angular/core": "20.3.4",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "20.3.4",
    "@angular/material": "^20.2.8",
    "@angular/platform-browser": "20.3.4",
    "@angular/platform-browser-dynamic": "20.3.4",
    "@angular/router": "20.3.4",
    "@sentry/angular": "^10.19.0",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "firebase": "^12.4.0",
    "install": "^0.13.0",
    "lodash-es": "^4.17.21",
    "ng2-charts": "^8.0.0",
    "ngx-quill": "^28.0.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.5",
    "@angular/cli": "20.3.5",
    "@angular/compiler-cli": "20.3.4",
    "@angular/language-service": "20.3.4",
    "@types/node": "^24.7.2",
    "codelyzer": "^6.0.2",
    "ts-node": "^10.9.2",
    "tslint": "^6.1.3",
    "typescript": "^5.9.3",
    "webpack-bundle-analyzer": "^4.10.2",
    "webpack-dev-server": "^5.2.2"
  }
}